import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  tags: string[];
  status: string;
  updateInfo: string;
  views: string;
  rating: number;
  isNew?: boolean;
}

export default function ComicCard({
  id,
  title,
  author,
  cover,
  tags,
  status,
  updateInfo,
  views,
  rating,
  isNew,
}: ComicCardProps) {
  return (
    <Link
      to={`/comic/${id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={cover}
          alt={`${title} - 丫丫漫画`}
          title={`${title} - 丫丫漫画在线免费阅读`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        
        {isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-xs font-medium bg-accent-500 text-background-50">
            NEW
          </span>
        )}
        
        <span className={`absolute top-2 right-2 px-2 py-0.5 rounded-md text-xs font-medium ${
          status === '已完结' ? 'bg-secondary-500 text-background-50' : 'bg-primary-500 text-background-50'
        }`}>
          {status}
        </span>

        <div className="absolute bottom-0 left-0 right-0 p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="flex items-center gap-2 text-background-50 text-xs">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {views}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-star-fill text-yellow-400"></i>
              {rating}
            </span>
          </div>
        </div>
      </div>

      <h3 className="text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
        {title}
      </h3>
      
      <p className="text-xs text-foreground-500 mt-1">{author}</p>
      
      <div className="flex items-center flex-wrap gap-1 mt-2">
        {tags.slice(0, 2).map((tag) => (
          <span
            key={tag}
            className="px-2 py-0.5 rounded-md text-xs bg-background-100 text-foreground-600"
          >
            {tag}
          </span>
        ))}
      </div>
      
      <p className="text-xs text-foreground-500 mt-2 truncate">{updateInfo}</p>
    </Link>
  );
}